import getDetalleSolicitudClient from './getDetalleSolicitudClient'
import purchaseDetailsClient from './purchaseDetailsClient'

export const getDetalleSolicitudClientPromise = getDetalleSolicitudClient
export const purchaseDetailsClientPromise = purchaseDetailsClient